import React, { FC } from 'react'
import { Layout } from 'components/Layout'
import ShoppingBagTemplate from 'components/Templates/account/ShoppingBagTemplate'

const ShoppingBag: FC = () => {
  return (
    <Layout title={'レジ袋オプション'}>
      <ShoppingBagTemplate />
    </Layout>
  )
}

export default ShoppingBag
